import * as THREE from "three";

export const NHMLables = [
//   {
//     Id: "Annotation_EisenzeitPickel",
//     Titel: "Eisenzeit Pickel",
//     Position: new THREE.Vector3(651.578, -0.338641, 178.704),
//     Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
//     Scale: 1,
//     isIFrame: true,
//     iFrameUrl:
//       "",
//     offset: -15,
//     offsetUp: 18,
//     follow: true,
//     lowModelCamZoom: 15,
//   },

  {
    Id: "Annotation_Kratze",
    Titel: "Kratze",
	TitelEn: "Bronze Age wooden scraper",
    Position: new THREE.Vector3(651.578, -0.338641, -179.504),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 2,
    isIFrame: true,
    iFrameUrl:
      "",
    offset: -15,
    offsetUp: 18,
    follow: true,
    lowModelCamZoom: 15,
  },

  {
    Id: "Annotation_Kuebel",
    Titel: "Holzeimer",
	TitelEn: "Bronze Age wooden bucket",
    Position: new THREE.Vector3(651.578, -0.338641,200),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 2,
    isIFrame: true,
    iFrameUrl:
      "",
    offset: 30,
    offsetUp: 18,
    follow: true,
    lowModelCamZoom: 15,
  },

//   {
//     Id: "Annotation_Leuchtspanbuendel",
//     Titel: "Leuchtspanbündel",
//     Position: new THREE.Vector3(604.329, -0.338641, -178.489),
//     Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
//     Scale: 1,
//     isIFrame: true,
//     iFrameUrl:
//       "",
//     offset: -15,
//     offsetUp: 18,
//     follow: true,
//     lowModelCamZoom: 15,
//   },
];

export const SalzweltenLables = [
  {
    Id: "Annotation_Grubenhund",
    Titel: "Grubenhunt",
	TitelEn: "The mine wagon",
    Position: new THREE.Vector3(660, -0.338641, 200),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 3.5,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/78ea22cdda8f406c821285ed1cda4a76/embed",
    offset: 0,
    offsetUp: 50,
    follow: true,
    lowModelCamZoom: 15,
  },
];

export const PapiermacherLables = [
  {
    Id: "Annotation_Salzschiff",
    Titel: "Salzzille",
	TitelEn: "Salt barges",
    Position: new THREE.Vector3(700, -0.338641, 200),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 2.5,
    isIFrame: true,
    iFrameUrl: "",
    offset:0,
    offsetUp: 45,
    follow: true,
    lowModelCamZoom: 15,
  },

  {
    Id: "Annotation_StadlPauraSalzkuefel",
    Titel: "Die Salzfässer um 1800",
	TitelEn: "Salt barrels around 1800",
    Position: new THREE.Vector3(700, -0.338641, -200),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 2,
    isIFrame: true,
    iFrameUrl: "https://sketchfab.com/models/d6936b48bf63438ab8066277901dcaed/embed",
    offset: 0,
    offsetUp: 45,
    follow: true,
    lowModelCamZoom: 15,
  },


];

export const KHofGmundenLables = [
	// {
	//   Id: "Annotation_KroneSalzamtleiter",
	//   Titel: "Die Totenkrone",
	//   Position: new THREE.Vector3(651.578, -0.338641, 178.704),
	//   Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
	//   Scale: 1,
	//   isIFrame: true,
	//   iFrameUrl: "https://sketchfab.com/models/07c42f43035d4e5ab03698374f2d8fdf/embed",
	//   offset: -15,
	//   offsetUp: 18,
	//   follow: true,
	//   lowModelCamZoom: 15,
	// },
  
	{
	  Id: "Annotation_PferdeeisenbahnTransportgespann",
	  Titel: "Pferdeeisenbahn Transportgespann",
	  TitelEn: "Salt transportation",
	  Position: new THREE.Vector3(700, -0.338641, -200),
	  Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
	  Scale: 1.5,
	  isIFrame: true,
	  iFrameUrl: "https://sketchfab.com/models/d9ac9d1cbe2246c28fad9912ebee77be/embed",
	  offset: 0,
	  offsetUp: 60,
	  follow: true,
	  lowModelCamZoom: 15,
	},
  
	{
	  Id: "Annotation_Kaiserschiff",
	  Titel: "Kaiserschiff",
	  TitelEn: "The Emperor’s ship",
	  Position: new THREE.Vector3(700, -0.338641, 200),
	  Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
	  Scale: 2.5,
	  isIFrame: true,
	  iFrameUrl: "https://sketchfab.com/models/502e1d6045db4da2be732a8ea574cf53/embed",
	  offset: 0,
	  offsetUp: 40,
	  follow: true,
	  lowModelCamZoom: 15,
	},
  
  ];
  

export const MuseumEbenseeLables = [
  {
    Id: "Annotation_EbenseeSoleleitung",
    Titel: "Soleleitung",
	TitelEn: "Brine conduit",
    Position: new THREE.Vector3(700, -0.338641, 200),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 2.5,
    isIFrame: true,
    iFrameUrl: "",
    offset: 0,
    offsetUp: 35,
    follow: true,
    lowModelCamZoom: 15,
  },

  {
    Id: "Annotation_Salzfabrik",
    Titel: "Saline",
	TitelEn: "Saltworks",
    Position: new THREE.Vector3(700, -0.338641, -200),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 2.5,
    isIFrame: true,
    iFrameUrl: "https://sketchfab.com/models/74e038ccaa4d41c9b9a5cbcbe07327ee/embed",
    offset: 0,
    offsetUp: 25,
    follow: true,
    lowModelCamZoom: 15,
  },
];

export const MuseumStadtBadIschlLables = [
	{
	  Id: "Annotation_BuchLebenChristiOffen",
	  Titel: "Katholisches Gebetbuch",
	  TitelEn: "Catholic prayer book",
	  Position: new THREE.Vector3(651.578, -0.338641, -200),
	  Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
	  Scale: 2,
	  isIFrame: true,
	  iFrameUrl: "https://sketchfab.com/models/cbde974594da40c88dfff1971f611252/embed",
	  offset: 0,
	  offsetUp: 65,
	  follow: true,
	  lowModelCamZoom: 15,
	},
  
	// {
	//   Id: "Annotation_BetbuchOffen",
	//   Titel: "Protestantisches Gebetbuch",
	//   Position: new THREE.Vector3(651.578, -0.338641, -179.504),
	//   Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
	//   Scale: 1,
	//   isIFrame: true,
	//   iFrameUrl: "https://sketchfab.com/models/7c6d30693e3f4c9581a2e96f404c6ad9/embed",
	//   offset: 0,
	//   offsetUp: 40,
	//   follow: true,
	//   lowModelCamZoom: 15,
	// },
	{
		Id: "Annotation_Jagdtasche",
		Titel: "Jagdtasche",
		TitelEn: "Hunting bag",
		Position: new THREE.Vector3(651.578, -0.338641, 200),
		Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
		Scale: 2.5,
		isIFrame: true,
		iFrameUrl: "https://sketchfab.com/models/dbc9c21886f7487bb57dea33560e719e/embed",
		offset: -30,
		offsetUp: 22,
		follow: true,
		lowModelCamZoom: 15,
	  },
  ];

  export const HeimatLandlerMuseumLables = [
	{
	  Id: "Annotation_Riedl",
	  Titel: "Riedl",
	  TitelEn: "Cushion",
	  Position: new THREE.Vector3(651.578, -0.338641, 200),
	  Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
	  Scale: 2.5,
	  isIFrame: true,
	  iFrameUrl: "https://sketchfab.com/models/311676ae2edb4656bee53cb393ecdff6/embed",
	  offset: 0,
	  offsetUp: 45,
	  follow: true,
	  lowModelCamZoom: 15,
	},
  
	{
	  Id: "Annotation_Tracht",
	  Titel: "Bürgertracht",
	  TitelEn: "Citizen's costume",
	  Position: new THREE.Vector3(651.578, -0.338641, -179.504),
	  Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
	  Scale: 2,
	  isIFrame: true,
	  iFrameUrl: "https://sketchfab.com/models/8f0fc840d7f4458f966cfd1ec3f67b0e/embed",
	  offset: -40,
	  offsetUp: 18,
	  follow: true,
	  lowModelCamZoom: 15,
	},

  ];

  export const HolzknechtMuseumLables = [
	{
	  Id: "Annotation_Arbeitsschuh",
	  Titel: "Arbeitsschuh",
	  TitelEn: "Arbeitsschuh",
	  Position: new THREE.Vector3(651.578, -0.338641, 200),
	  Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
	  Scale: 2,
	  isIFrame: true,
	  iFrameUrl: "https://sketchfab.com/models/c35eea87b92c451db9774bb020fa7dca/embed",
	  offset: 0,
	  offsetUp: 40,
	  follow: true,
	  lowModelCamZoom: 15,
	},
  


  ];

  export const WeltErbeMuseumHallstattLables = [
	{
	  Id: "Annotation_Stierhornschenkelschale",
	  Titel: "Stierkopftasse",
	  TitelEn: "Bull's head cup",
	  Position: new THREE.Vector3(651.578, -0.338641, 178.704),
	  Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
	  Scale: 2,
	  isIFrame: true,
	  iFrameUrl: "",
	  offset: 0,
	  offsetUp: 50,
	  follow: true,
	  lowModelCamZoom: 15,
	},
  


  ];

  export const KHofBadAuseeLables = [
	{
	  Id: "Annotation_Flinserl",
	  Titel: "Flinserl",
	  TitelEn: "Flinserl",
	  Position: new THREE.Vector3(651.578, -0.338641, 178.704),
	  Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
	  Scale: 3,
	  isIFrame: true,
	  iFrameUrl: "https://sketchfab.com/models/b54703dcd2da43d7ab2eff6c13848c70/embed",
	  offset: -15,
	  offsetUp: 18,
	  follow: true,
	  lowModelCamZoom: 15,
	},

	// {
	// 	Id: "Annotation_Ammoniten",
	// 	Titel: "Ammoniten",
	// 	Position: new THREE.Vector3(651.578, -0.338641, -179.504),
	// 	Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
	// 	Scale: 1,
	// 	isIFrame: true,
	// 	iFrameUrl: "https://sketchfab.com/models/55a3ccd2acdf48d0ad28ce930d51feaf/embed",
	// 	offset: -15,
	// 	offsetUp: 18,
	// 	follow: true,
	// 	lowModelCamZoom: 15,
	//   },

	  {
		Id: "Annotation_Trommelweibertrommel",
		Titel: "Trommelweibertrommel",
		TitelEn: "Carnival drum",
		Position: new THREE.Vector3(651.578, -0.338641, -200),
		Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
		Scale: 2.5,
		isIFrame: true,
		iFrameUrl: "https://sketchfab.com/models/760113dec81144cdb3c4aae6e26a1410/embed",
		offset: 0,
		offsetUp: 60,
		follow: true,
		lowModelCamZoom: 15,
	  },

	//   {
	// 	Id: "Annotation_Pfeifferl",
	// 	Titel: "Pfeifferl",
	// 	Position: new THREE.Vector3(604.329, -0.338641, -178.489),
	// 	Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
	// 	Scale: 1,
	// 	isIFrame: true,
	// 	iFrameUrl: "https://sketchfab.com/models/51a03b497a66460fabff9186f3602990/embed",
	// 	offset: -15,
	// 	offsetUp: 18,
	// 	follow: true,
	// 	lowModelCamZoom: 15,
	//   },
  


  ];

